import VideoPlayer from "../../../common/components/VideoPlayer";

const PracticeVideo = ({ url, onLoadError, onEnd }: PracticeVideoProps): JSX.Element => {
    return <VideoPlayer url={url} onLoadError={onLoadError} onEnd={onEnd} />;
};

export default PracticeVideo;

interface PracticeVideoProps {
    url: string;
    onLoadError: () => void;
    onEnd: () => void;
}
